export default __webpack_public_path__ + "static/media/estado-15.dc9f7067.svg";